/*
 * Config values here may be at most 16 characters to be
 * remote-controllable by GameAnalytics.
 *
 * F = "Factor"
 */
export const Config = {
    /* Warning: Changing this affects the player's levels!
     * Only change for new users.
     * Since all level-ramps are based on factors, the only effect this will have is
     * larger numbers in the XP reward screen. */
    xpInc: 21,

    /* How much percentage of XP_INC the player is rewarded per tag */
    xpPerTagF: 0.05,

    /* How much percentage of XP_INC the player is rewarded for a win  */
    xpPerWinF: 0.2,
};
